let common = require('../admin-common.js');

$(document).on('click', '.btn-edit-info', function() {
  $('#reservation-warning-modal').modal('show');
});

$(document).on('click', '.btn-update-info-reservation', function() {
  $('#reservation-warning-modal').modal('hide');
  $.ajax({
    url: $('.edit_reservation').attr('action'),
    type: 'PATCH',
    dataType: 'script',
    data: $('form.edit_reservation').serialize(),
    success: function() {
      return true;
    }
  });
});

$(document).on('click', '.export-csv-orders', function() {
  let params = window.location.search.substr(1);
  let url = '/agency/orders/export?' + params;
  handleDownloadCsvFile(url);
});

$(document).on('click', '.btn-yes-edit-reservation', function (event) {
  let id = $(this).data('id');
  $('#reservation-delete-modal').modal('hide');
  $.ajax({
    url: '/agency/orders/change_reservation_status',
    type: 'PATCH',
    dataType: 'script',
    data: { id: id },
    success: function(){
      return true;
    }
  });
});

$(document).ready(function() {
  $('.select2-product-code, .select2-school-id').select2({ language: common.noResultMessage });
});

$(document).on('click', '.download-order-list-btn', function() {
  const selectedOrders = $('.order-checkbox:checked').map(function() {
    return $(this).attr('order_ids');
  }).get();

  if (selectedOrders.length === 0) {
    $('.warning-text p').text(common.MSG_EXTRACT_CSV);
    $('#warning-delete-data-modal').modal('show');
    return;
  }

  window.location.href = '/agency/orders/download_order_list?order_ids=' + selectedOrders;
});
